import { SectionRowViewModel } from './SectionRowViewModel';

export class SectionRowViewModelBlended extends SectionRowViewModel {
  getStrainTypeColor(): string {
    return '#222222';
  }
}
